import React, { useMemo, useState } from "react";
import { View, StyleSheet, TouchableOpacity, Text } from "react-native";
import { useCollectionStore } from "../../store/collectionStore";
import { Menu } from "react-native-paper";
import { ModalType, useModalStore } from "../../store/modalStore";
import { CustomIcon } from "../CustomIcon";
import GridLayoutSelector from "./GridLayoutSelector";
import getGlobalStyles from "../../globalStyles";
import { useThemeSettings } from "../../ThemeProvider";
import { useActiveTabStore } from "../../store/activeTabStore";
import TourStep from "../productTours/TourStep";

function TemplateHeader() {

  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
  const selectedCollection = useCollectionStore(s => s.selectedCollection);
  const layout = useCollectionStore(s => s.layout);
  const setLayout = useCollectionStore(s => s.setLayout);

  const activetab = useActiveTabStore((state) => state.activetab);

  const { setModalShown } = useModalStore();
  const [menuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => setMenuVisible(!menuVisible);

  const handleShare = () => {
    setModalShown(ModalType.SHARE_ARTICLE, {
      collection: selectedCollection,
      sharedFrom: activetab,
      shareCollection: true,
    });
  };
  return (
    <View style={styles.header}>
      <Text style={[styles.title, { color: theme?.colors?.primary }]}>
        {selectedCollection?.title}
      </Text>
      <View
        style={{
          alignItems: "flex-end",
          flexDirection: "row",
          paddingBottom: 10,
        }}
      >
        <Menu
          visible={menuVisible}
          anchorPosition="bottom"
          contentStyle={{
            backgroundColor: "transparent",
            elevation: 0,
            shadowColor: "transparent",
            shadowOpacity: 0,
            shadowRadius: 0,
            shadowOffset: { width: 0, height: 0 },
          }}
          onDismiss={toggleMenu}
          anchor={
            <TouchableOpacity
              id="templateMenu"
              style={[
                gStyles.buttonStyle,
                gStyles.buttonCircle,
                { marginRight: 10 },
                menuVisible && { backgroundColor: theme.colors.primary },
              ]}
              onPress={() => setMenuVisible(true)}
            >
              <CustomIcon
                size={16}
                icon="template"
                color={
                  menuVisible ? theme?.colors?.white : theme?.colors?.primary
                }
              />
            </TouchableOpacity>
          }
        >
          <GridLayoutSelector
            value={layout}
            onChange={(v) => {
              setLayout(v);
              toggleMenu();
            }}
          />
        </Menu>
        <TourStep order={5}>
          <TouchableOpacity
            id="templateShare"
            style={[gStyles.buttonStyle, gStyles.buttonCircle]}
            onPress={handleShare}
          >
            <CustomIcon icon="share" size={16} color={theme?.colors?.primary} />
          </TouchableOpacity>
        </TourStep>
      </View>
    </View>
  );
}
export default React.memo(TemplateHeader);
const styles = StyleSheet.create({
  title: {
    fontSize: 26,
    marginLeft: 10,
    marginBottom: 10,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  }
});
